<style lang="stylus">
.headersearchwrap
  position: relative
  .searchiptwrap, .searchiptwrapv2, .searchiptwrapv3
    .el-input__inner
      &:focus
        border-color: #dcdfe6
      &::-webkit-input-placeholder
        color: #999
      &:-moz-placeholder
        color: #999
      &::-moz-placeholder
        color: #999
      &:-ms-input-placeholder
        color: #999
  .searchiptwrap
    .el-input__inner
      height: 50px
      line-height: @height
      padding-left: 30px
    .el-input-group__append
      border: none
      .el-button
        height: 50px
        width: 58px
        border-radius: 0 4px 4px 0
        background-color: #fd7266
        border-color: #fd7266
        font-size: 21px
        // color: #fff
        padding: 0
        .el-icon-search
          font-size: 25px
          font-weight: bold
  .searchiptwrapv100
    width: 345px
    .el-input__inner
      height: 40px
      line-height: @height
      padding-left: 48px
      // border-radius: @height
      background transparent
      // border none
      border-radius: 20px
      // color #fff
    .el-input__inner:focus
      border: 1px solid #DCDFE6;
    input::-webkit-input-placeholder
      // color rgba(255,255,255,0.6) !important
    .el-input__prefix
      display:flex;
      align-items:center;
      .el-icon-search
        font-size: 24px
        // color: #fd7266
        // color: rgba(255,255,255,0.8)
        // font-weight: bold
        padding: 0 11px
        width: auto
        height:40px;
  .searchiptwrapv3
    .el-input__inner
      height: 54px
      line-height: @height
      background-color: transparent
      border: none
      border-bottom: 1px solid #bee0ff
      color: rgba(206,254,255,0.59)
      font-size: 22px
      &::-webkit-input-placeholder
        color: rgba(206,254,255,0.45)
      &::-moz-placeholder         /* Mozilla Firefox 19+ */
        color: rgba(206,254,255,0.45)
      &:-moz-placeholder          /* Mozilla Firefox 4 to 18 */
        color: rgba(206,254,255,0.45)
      &:-ms-input-placeholder     /* Internet Explorer 10-11 */
        color: rgba(206,254,255,0.45)
    .el-input__suffix
      //
  .searchfloatpanel
    position: absolute
    top: 60px
    // width: calc(100% - 59px)
    // margin-top 20px
    width: 483px
    // border-radius: 6px
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 30px 0px rgba(0,0,0,0.17);
    border-radius:10px;
    z-index:99
    .title
      height: 32px
      line-height: @height
      color: #666
      font-size: 16px
      border-bottom: 1px solid #e5e5e5
      margin: 11px 30px 0
      a
        float: right
        font-size: 14px
        color: $basecolor
    .searchcommonul
      padding: 0 30px
      min-height: 50px
      position: relative
    .postul
      margin: 12px 0 3px
      li
        padding: 0 9px
        height: 28px
        line-height: @height
        cursor: pointer
        display: flex
        justify-content: space-between
        &:hover
          background-color: #f0f7fb
        .postname
          flex: auto
          color: #444
          padding-right: 28px
        .username
          flex: none
          color: #999
          font-size: 12px
    .userul
      margin: 22px 0
      .searchuserulitem
        li
          // width: 70px
          width 50%
          display flex
          padding: 8px 4px
          // text-align: center
          cursor: pointer
          float: left
          min-height 55px
          &:hover
            background-color: #f0f7fb
          img
            width: 35px
            height: 35px
            border-radius: 50%
          p
            color: #444
          div
            flex 1
            margin-left 14px
            p
              color: #888
              font-size 12px
            .center
              display flex
              align-items center
              height 35px
    .informationul
      margin: 15px 0
    .allresult
      font-size: 14px
      height: 60px
      line-height 53px
      text-align: center
      button
        height: 34px
        width: 120px
        border-radius: @height
    .searchqrcodewrap
      padding: 17px 0 0
      background-color: #f6faff
      .searchqrcodetop
        color: #ff8d27
        text-align: center
      .searchqrcodebot
        display: flex
        justify-content: center
        .searchqrcodeimg
          margin-top: 20px
          text-align: center
          &.atright
            margin-left: 39px
          img
            width: 120px
            height: @width
          p
            color: #999
            margin-top: 4px
    .searchqrcoderightwrap
      position: absolute
      top: 20px
      right: 0
      width: 235px
      text-align: center
      & > div
        margin-top: 11px
        p
          color: rgba(255,255,255,0.9)
          margin-top: 3px
  &.fullscreensearchsearch
    a
      &:hover
        color: #fff !important
    .searchfloatpanel
      width: 100%
      padding-right: 238px
      top: 156%
      background-color: transparent
      box-shadow: none
      .title
        color: rgba(255,255,255,0.9)
        border-bottom: 1px solid rgba(255,255,255,0.29)
        a
          float: right
          font-size: 14px
          color: rgba(255,255,255,0.9)
      .searchcommonul
        .el-loading-mask
          background-color: transparent
      .postul
        li
          &:hover
            background-color: transparent
          .postname
            color: rgba(255,255,255,0.9)
          .username
            color: rgba(255,255,255,0.9)
      .userul
        .searchuserulitem
          li
            &:hover
              background-color: transparent
            p
              color: rgba(255,255,255,0.9)
      .allresult
        button
          background-color: transparent
          color: #cefeff
          border-color: #cefeff
  em
    font-style: normal
    color: #f00 !important
</style>

<template>
  <div v-if="type != 'searchpagehidden'" :class="{fullscreensearchsearch: type == 'fullscreensearch'}" class="headersearchwrap" v-clickOutSide="closePanel">
    <el-input
      v-if="type == 'search'"
      v-model.trim="keyword"
      @keyup.enter.native="goToSearch(false)"
   
      @focus="openPanel"
      :placeholder="type == 'headersearch' ? '输入关键字搜索' : '请输入关键词，搜索知识、用户、资讯等...'"
      class="searchiptwrap">
      <el-button @click="goToSearch(false)" slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <!--    @input="wordChange" -->

    <el-input
      v-if="type == 'bannersearch'"
      v-model.trim="keyword"
      @keyup.enter.native="goToSearch(false)"
      ref="focus"
      @focus="openPanel"
      :placeholder="type == 'headersearch' ? '输入关键字搜索' : '搜索关键字，搜索课程、用户、知识'"
      class="searchiptwrapv100">
      <i @click="goToSearch(false)" slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <!--       @input="wordChange" -->

    <el-input
      v-if="type == 'fullscreensearch'"
      v-model.trim="keyword"
      @keyup.enter.native="goToSearch(false)"

      @focus="openPanel"
      clearable
      :placeholder="type == 'headersearch' ? '输入关键字搜索' : '搜索关键字、知识、用户、资讯...'"
      class="searchiptwrapv3">
    </el-input>
    <!--       @input="wordChange" -->

    <div v-if="searchPanel && searchPanelState" :style="{width: type == 'headersearch' ? '100%' : ''}" class="floatpanel searchfloatpanel">

      <div class="title">{{searchNav.find(e => e.type == 'post').name}} <a @click="goToSearch(searchNav.find(e => e.type == 'post').url)" href="javascript:;">更多 +</a></div>
      <ul class="searchcommonul postul" v-loading="searchNav.find(e => e.type == 'post').isloading">
        <li @click="searchPanel = false, $emit('closeFull') , $router.push({name: 'post', params: {post_id: list.post_id}})"  v-for="list in searchNav.find(e => e.type == 'post').list">
          <a class="postname ellipsis1" href="javascript:;" v-html="list.post_title"></a>
          <span class="username">{{list.creator_name}}&nbsp;&nbsp;{{list.update_time | timeconvert}}</span>
        </li>
        <div v-if="!searchNav.find(e => e.type == 'post').list.length && !searchNav.find(e => e.type == 'post').isloading" class="nodatalist">未搜索到相关知识</div>
      </ul>

      <div class="title">{{searchNav.find(e => e.type == 'user').name}} <a @click="goToSearch(searchNav.find(e => e.type == 'user').url)" href="javascript:;">更多 +</a></div>
      <ul class="searchcommonul userul" v-loading="searchNav.find(e => e.type == 'user').isloading">
        <div class="searchuserulitem clearfix">
          <li
            @click="$emit('closeFull'),$router.push({name: 'personalCenter', params: {id: list.user_id}}) "
            v-for="list in searchNav.find(e => e.type == 'user').list"
            :style="{width: type == 'headersearch' ? '66px' : '' }">
            <img :src="$avatarHash(list.user_id)">

            <div class="ellipsis1">
              <p  :style="{color: type==='fullscreensearch' ? '#fff' : '#333'}"><span style="fontSize: 14px" v-html="list.real_name"></span></p>
              <p class="ellipsis1" :class="{center: !list.real_name}" v-if="list.vip === 300">
                <span v-if="list.real_name">昵称: </span>
                <span v-html="list.user_name"  class="ellipsis1"></span>
              </p>
              <p class="ellipsis1" v-else>
                <span>律所:</span>
                <span class="ellipsis1">{{list.company || ''}}</span>
              </p>
            </div>

          </li>
        </div>
        <div v-if="!searchNav.find(e => e.type == 'user').list.length && !searchNav.find(e => e.type == 'user').isloading" class="nodatalist">未搜索到相关用户</div>
      </ul>

      <!-- <div class="title">{{searchNav.find(e => e.type == 'information').name}} <a @click="goToSearch(searchNav.find(e => e.type == 'information').url)" href="javascript:;">更多 +</a></div>
      <ul class="searchcommonul postul informationul" v-loading="searchNav.find(e => e.type == 'information').isloading">
        <li @click="searchPanel = false, $emit('closeFull'),$router.push({name: 'post', params: {post_id: list.post_id}})" v-for="list in searchNav.find(e => e.type == 'information').list">
          <a class="postname ellipsis1" href="javascript:;" v-html="list.post_title"></a>
          <span class="username">{{list.creator_name}}&nbsp;&nbsp;{{list.update_time | timeconvert}}</span>
        </li>
        <div v-if="!searchNav.find(e => e.type == 'information').list.length && !searchNav.find(e => e.type == 'information').isloading" class="nodatalist">未搜索到相关资讯</div>
      </ul> -->

      <div class="title">{{searchNav.find(e => e.type == 'course').name}} <a @click="goToSearch(searchNav.find(e => e.type == 'course').url)" href="javascript:;">更多 +</a></div>
      <ul class="searchcommonul postul informationul" v-loading="searchNav.find(e => e.type == 'course').isloading">
        <li @click="searchPanel = false, $emit('closeFull'),$router.push({name: 'courseInfo', params: {course_id: list.id}})" v-for="list in searchNav.find(e => e.type == 'course').list">
          <a class="postname ellipsis1" href="javascript:;" v-html="list.title"></a>
          <span class="username">{{list.speaker}}&nbsp;&nbsp;{{list.start_time | timeconvert}}</span>
        </li>
        <div v-if="!searchNav.find(e => e.type == 'course').list.length && !searchNav.find(e => e.type == 'course').isloading" class="nodatalist">未搜索到相关资讯</div>
      </ul>

      <div class="allresult">
        <el-button @click="goToSearch(false)" type="primary" plain size="small">查看全部结果</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'HeaderSearchs',
  data() {
    return {
      searchPanel: false,
      keyword: '',
      searchNav: [
        {
          type: 'post',
          name: '知识',
          url: 'posts',
          list: [],
          perpage: 2,
          isloading: false,
          searchpageSort: 2,
          isfirst: true,
          isEmpty: false,
          total: 0,
          MenuItem: [
            {name: '全部', url: 'posts', active: true},
            {name: '公开知识', url: 'outwardposts', active: false},
            {name: '我的知识', url: 'myposts', active: false},
            {name: '授权知识', url: 'authposts', active: false},
          ],
          curUrl: 'posts',
        },
        {
          type: 'user',
          name: '用户',
          url: 'user',
          list: [],
          perpage: 6,
          isloading: false,
          searchpageSort: 1,
          isfirst: true,
          isEmpty: false,
          total: 0,
          MenuItem: [
            {name: '全部', url: 'user', active: true},
            {name: '已关注', url: 'myfollowusers', active: false},
            {name: '未关注', url: 'mynotfollowusers', active: false},
            {name: '认证用户', url: 'leveluser', active: false},
            {name: '普通用户', url: 'generaluser', active: false},
          ],
          curUrl: 'user',
        },
        // {
        //   type: 'information',
        //   name: '资讯',
        //   url: 'information',
        //   list: [],
        //   perpage: 2,
        //   isloading: false,
        //   searchpageSort: 3,
        //   isfirst: true,
        //   isEmpty: false,
        //   total: 0,
        //   curUrl: 'information',
        // },
        {
          type:'course',
          name: '课程',
          url: 'course',
          list: [],
          perpage: 2,
          isloading: false,
          searchpageSort: 3,
          isfirst: true,
          isEmpty: false,
          total: 0,
          curUrl: 'course',
        }
      ],
      timer: null
    }
  },
  props: {
    type: {
      type: String,
      default: 'search'   //search  searchpagehidden  headersearch  bannersearch fullscreensearch
    }
  },
  computed: {
    searchPanelState() {
      let s;
      if( this.keyword != '' ){
          s = true;
      }else{
          s = false;
      }
      return s;
    },
    loginStatus() {
      return this.$store.state.loginStatus;
    },
  },
  beforeMount() {
    if( this.type == 'searchpagehidden' ){
      this.searchNav.forEach(e => {
        e.perpage = 16;
      });
    }
    if( this.type == 'headersearch' ){
      this.searchNav.forEach(e => {
        if( e.type == 'post' || e.type == 'information' ){
          e.perpage = 2;
        }else{
          e.perpage = 5;
        }
      });
    }
    if( this.type == 'fullscreensearch' ){
      this.searchNav.forEach(e => {
        if( e.type == 'post' || e.type == 'information' ){
          e.perpage = 2;
        }else{
          e.perpage = 8;
        }
      });
    }
  },
  mounted() {
    this.$emit('getNav', this.searchNav);
    if (this.type === 'bannersearch') {
      this.$refs.focus.focus()
    }
  },
  methods: {
    goToSearch(type) {
      if( this.keyword == '' ){
          return false;
      }

      // 清除定时器
      window.clearTimeout(this.timer);
      // 关闭展示面板
      this.searchPanel = false;
      this.$emit('closeFull');
      let query = { keyword: this.keyword};
      if( type ){
          query.type = type;
          this.$router.push({path:'/search',query:{keyword:this.keyword,type:type}})
      } else {
        this.$router.push({path:'/search',query:{keyword:this.keyword}})
      }
    },
    wordChange() {
      if( this.keyword == '' ){
          return false;
      }
      this.searchPanel = true;

      // 清空数据
      this.searchNav.forEach(e => {
        e.list = [];
        e.isloading = true;
      });

      // 清除定时器
      window.clearTimeout(this.timer);
      // 延时请求数据
      this.timer = setTimeout(() => {
        this.searchNav.forEach(e => {
          this.getData(e.url, e, this.keyword);
        });
      }, 500);
    },
    openPanel() {
      this.searchPanel = true;
    },
    closePanel() {
      if( this.type == 'fullscreensearch' ){
        return;
      }
      this.searchPanel = false;
    },
    getData(type, obj, keyword, cb) {
      if( type == 'posts' && !this.loginStatus ){
        type = 'outwardposts';
      }
      if(type != 'course'){
          this.$http.get(`/search/${type}/${keyword}`, { params: { page: Math.ceil(obj.list.length / obj.perpage) + 1, perpage: obj.perpage}}).then(response => {
          if( response.data.retcode == 0 ){
            let arr = obj.list.concat(response.data.data);
            // 去重
            let unique = {};
            arr.forEach(function(gpa){ unique[ JSON.stringify(gpa) ] = gpa });
            arr = Object.keys(unique).map(function(u){return JSON.parse(u) });
            obj.list = arr;
            obj.total = response.data.total;
          }else{
            this.$message.error( response.data.errmsg );
          }
          obj.isloading = false;
          if( cb ){
            cb(response.data.data.length);
          }
        }).catch(err => {
          obj.isloading = false;
          if( cb ){
            cb(0);
          }
        });
      }else{
        this.$http.get(`/wxm/course/index`,{params: { page: Math.ceil(obj.list.length / obj.perpage) + 1, per_page: obj.perpage,title:keyword}}).then(response => {
          if(response.data.retcode == 0){
            let arr = obj.list.concat(response.data.data.data);
            // 去重
            let unique = {};
            arr.forEach(function(gpa){ unique[ JSON.stringify(gpa) ] = gpa });
            arr = Object.keys(unique).map(function(u){return JSON.parse(u) });
            obj.list = arr;
            obj.total = response.data.data.total;
          }else{
            this.$message.error( response.data.errmsg );
          }
          obj.isloading = false;
          if( cb ){
            cb(response.data.data.data.length);
          }
        }).catch(err => {
          obj.isloading = false;
          if( cb ){
            cb(0);
          }
        });
      }
    },
  },
  watch: {
    keyword(v, ov) {
      // console.log(v, ov)
      if (v != '' ) {
        this.wordChange()
      }
    }
  },
  filters: {
    timeconvert(date) {
      return moment(date).format('YY-MM-DD');
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/search/headerSearchs.vue